export const CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  
  // BASE_URL: "http://3.12.248.21:9982", /////// My - priview Server /////
  // BASE_URL: "http://174.138.21.74:9982", /////// Creatoro Server /////
  // BASE_URL: "https://customerapi.kitchenparameter.com", ////// Client Server /////
};
